export default __webpack_public_path__ + "static/media/hdfcLife.aaf83374.png";